import { z } from "zod";

export const SubscriptionRequestSchema = z.object({
  email: z.string().email("Invalid email format"),
});

export type SubscriptionRequest = z.infer<typeof SubscriptionRequestSchema>;

export const UploadImageRespSchema = z.object({
  url: z.string().url(),
});
export type UploadImageResp = z.infer<typeof UploadImageRespSchema>;
